<!--

@@author        j0Shi
@@date          2019.06.18
@@desc          Standard template for person selects
@@usedby        ObjectVavancyForm > Object

-->
<template>
  <label
    class="input-group persons"
    for="select-persons"
  >
    <!-- changed because divs not allowed in label -->
    <span class="input-group-prepend">
      <span
        class="input-group-text"
      >
        <i class="icon"><icon-user-friends-alternative /></i>
      </span>
    </span>
    <selectStandard
      id="select-persons"
      v-model="personsCount"
      :options="optionPersons"
      class="form-control persons"
      @input="$emit('input', $event)"
    />
  </label>
</template>

<script>
import selectStandard from 'components/SelectStandard.vue';

/* ICONS */
import IconUserFriendsAlternative from 'ICON:IconUserFriendsAlternative';

export default {
  name: 'SelectPersons',
  components: { selectStandard, IconUserFriendsAlternative },
  props: {
    // max persons that an object can hold
    personsMax: {
      type: Number,
      default: 2,
    },
    adultsMax: {
      type: Number,
      default: 99,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    // predefined value for the select
    default: {
      type: String,
      default: '2',
    },
  },
  computed: {
    // calculate options for the select based on max persons allowed
    optionPersons() {
      const options = [];
      for (let i = 1; i <= this.personsMax; i += 1) {
        if (i > this.adultsMax && this.adultsMax > 0) {
          options.push({ value: i, label: `${i} ${this.$t('common:label.person', { count: i })} ${this.$t('common:label.personWithChilds', { count: i - this.adultsMax, child: i - this.adultsMax })}` });
        } else {
          options.push({ value: i, label: `${i} ${this.$t('common:label.person', { count: i })}` });
        }
      }
      return options;
    },
    personsCount: {
      get() {
        return this.value;
      },
      set(newValue) {
        return newValue;
      },
    },
  },
  watch: {
  },
};
</script>
